import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import SearchPage from "./pages/SearchPage";
import AssessmentPage from "./pages/AssessmentPage";
import StartupLoginPage from "./pages/StartupLoginPage";
import ListProductPage from "./pages/ListProductPage";
import AboutPage from "./pages/AboutPage";
import AdminPage from "./pages/AdminPage";
import DemoDocumentation from "./pages/DemoDocumentation";
import DemoResultsPage from "./pages/DemoResultsPage";
import PricingPage from "./pages/PricingPage";
import BrowsePage from "./pages/BrowsePage";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/results" element={<DemoResultsPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/assessment" element={<AssessmentPage />} />
          <Route path="/startup/login" element={<StartupLoginPage />} />
          <Route path="/list-product" element={<ListProductPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/demo" element={<DemoDocumentation />} />
          <Route path="/browse" element={<BrowsePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;